import React from "react";

const UserWidgets = () => {
  return (
    <div style={{width:"100%",height:"80%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
      <section style={{width:"100%",height:"80%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
        <div style={{width:"100%",height:"80%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
          <h4>Welcome to KVR STARLIGHT MEDICAL ACADEMY</h4>
        </div>
      </section>
    </div>
  );
};

export default UserWidgets;
